/*
 * @Author: zhengshuhua
 * @Date: 2022-02-16 09:40:45
 * @LastEditors: zhangran(b742774335@163.com)
 * @LastEditTime: 2023-08-03 14:56:51
 * @Description: file content
 * @FilePath: \jilinhospital-web\src\request\api\modelResearch.js
 */
import { get } from '../axios'
const systemConfig = {
	// 查询系统配置
	fetchSysConfigSelect: params => get('/web/sys/config/querySystemInfo', params)
}
export default systemConfig
